import HeatMapTab from './HeatMapTab';

export default HeatMapTab;
